import React, { createContext, useReducer } from "react";
import PaymentReducer from "../reducers/payment.reducer";

const initialState: any = {
  history: [],
  // latestHistory: null,
  latestHistory: [
    {
      from: new Date(),
      to: new Date(),
      amount: 99
    },
    {
      from: new Date(),
      to: new Date(),
      amount: 99
    },
  ],
  details: {},
  // creditCardDetails: null,
  creditCardDetails: {
    name: "Zyad Yasser",
    address: "Some cool address",
    cardType: "visa",
    cardData: "Some stuff collected by stripe"
  },
  // upComingPayment: null,
  upComingPayment: {
    from: new Date(),
    to: new Date(),
    amount: 99
  },
};

export const PaymentContext = createContext(initialState);
export const PaymentProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(PaymentReducer, initialState);

  function setPaymentHistory(history: string) {
    dispatch({
      type: "SET_PAYMENT_HISTORY",
      payload: { history }
    });
  }

  function setLatestPaymentHistory(latestHistory: any) {
    dispatch({
      type: "SET_LATEST_PAYMENT_HISTORY",
      payload: { latestHistory }
    });
  }

  function setPaymentDetails(details: any) {
    dispatch({
      type: "SET_PAYMENT_DETAILS",
      payload: { details }
    });
  }

  return (
    <PaymentContext.Provider
      value={{
        ...state,
        setPaymentDetails,
        setPaymentHistory,
        setLatestPaymentHistory
      }}
    >
      { children }
    </PaymentContext.Provider>
  );
};